import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import Role from '@/views/Authorization/models/role'

@Component({
    inheritAttrs: false,
    name: 'RoleEdit',
    components: { DialogTemplate },
})
export default class RoleEdit extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    get role(): Role {
        return this.props.role
    }

    valid = true
    loading = false
    roleName = this.role['name']
    preconditionFailed = false
    error = false
    isContractorRole = this.role.isContractorRole
    autoAddCheckedInUsers = this.role['autoAddCheckedInUsers']

    async update(event) {
        event.preventDefault()
        if (this.valid && !this.loading) {
            this.loading = true
            let data = {
                attributes: {
                    name: this.roleName,
                    isSuggestedContractorRole: this.isContractorRole,
                    autoAddCheckedInUsers: this.autoAddCheckedInUsers,
                },
            }

            await this.role.patchRole(data).catch(async (error) => {
                this.error = true

                if (error.status == '412') {
                    this.$store.commit('closeSnackbar')
                    this.preconditionFailed = true
                }
            })
            if (!this.error) this.$emit('close', true)

            this.loading = false
        }
    }
}
